import React, { useState } from 'react'
import { Button } from 'reactstrap'
import { Divider, message } from 'antd'

import ServerSideSelect from '../../../components/ServerSideSelect'
import { searchDocuments } from '../../Documents/services'

import { updateFaq } from '../services'
import { handleError } from '../../../helpers'

const FaqDocumentWidget = ({ faq, reload }) => {
    const [loading, setLoading] = useState(false)
    const [selectedDocument, setSelectedDocument] = useState(faq.document ? {
        label: faq.document.title,
        value: faq.document.id
    } : [])

    if (!faq) return null

    const handleDocumentChange = (documentId = null) => {
        setLoading(true)
        updateFaq(faq.id, { document_id: documentId ? documentId : null })
            .then(() => {
                message.success('Documento actualizado correctamente')
                reload()
            })
            .catch(error => handleError(error))
            .finally(() => setLoading(false))
    }

    return (
        <React.Fragment>
            <ServerSideSelect
                value={selectedDocument}
                placeholder="Seleccione un documento"
                fetchOptions={searchDocuments}
                onChange={value => setSelectedDocument(value)}
                style={{ width: '100%', marginBottom: '7px' }}
            />
            <Button 
                color='primary' 
                outline 
                onClick={() => handleDocumentChange(selectedDocument.value)}
                disabled={!selectedDocument.value || loading}
            >
                Actualizar Documento
            </Button>
            {faq.document && (
                <div className="mt-3">
                    <p className="mb-2">
                        <strong>Documento: </strong>{faq.document.title}
                    </p>
                    <a 
                        href={faq.document.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                    >
                        Ver Documento
                    </a>
                    <Divider type='vertical' />
                    <span
                        className="ml-2 text-link"
                        onClick={() => handleDocumentChange(null)}
                    >
                        Desasociar Documento
                    </span>
                </div>
            )}
        </React.Fragment>
    )
}

export default FaqDocumentWidget